import { Box, styled, Typography } from '@mui/material';
import { AccessCodeSVG } from 'components/SignUpForm/Steps/TransitionSteps/AccessCodeSVG';
import { useThemeUtils } from 'contexts/ThemeContext/hooks/useThemeUtils';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import React from 'react';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(4),
  minHeight: '500px',
}));

export const SignUpHelpDialogConsent = () => {
  const { theme } = useThemeUtils();
  const { translation } = useTranslationContext();

  return (
    <StyledBox>
      <AccessCodeSVG
        brandPrimary={theme.palette.primary.main}
        brandSecondary={theme.palette.secondary.main}
        brandPrimaryBackground={theme.palette.brandBackgroundPrimary.main}
        brandSecondaryBackground={theme.palette.brandBackgroundSecondary.main}
        brandShade1={theme.palette.brandShade1.main}
        brandShade2={theme.palette.brandShade2.main}
        brandTint={theme.palette.brandTint.main}
      />
      <Typography variant="body1" color="grey.800" textAlign="center">
        {translation('onboarding_disclaimer_plain')}
      </Typography>
      <Typography variant="body1" color="grey.800" textAlign="center" fontWeight={700}>
        {translation('onboarding_disclaimer_bold')}
      </Typography>
    </StyledBox>
  );
};
